(() => {
  const CARD_SELECTOR = '.stiffy-upsell-card[data-stiffy-upsell-card]';
  const SELECT_SELECTOR = '.stiffy-upsell-select';

  function updateCard(select) {
    const card = select.closest(CARD_SELECTOR);
    if (!card) return;

    const wrapper = card.closest('.wbproduct-container');
    if (!wrapper) return;

    const option = select.options[select.selectedIndex];
    if (!option) return;

    const input = wrapper.querySelector('[data-stiffy-upsell-variant-id]');
    const button = wrapper.querySelector('[data-stiffy-upsell-add]');
    const priceBox = wrapper.querySelector('[data-stiffy-upsell-price]');
    const mediaItems = wrapper.querySelectorAll('.product__media-item');

    if (input) input.value = option.value;

    if (button) {
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      const label = button.querySelector('span');
      if (label) label.textContent = available ? 'Add to cart' : 'Sold out';
    }

    if (priceBox && option.dataset.price) {
      const price = option.dataset.price;
      const comparePrice = option.dataset.comparePrice || '';
      const regularBox = priceBox.querySelector('.price__regular');
      const saleBox = priceBox.querySelector('.price__sale');
      const regularPrice = regularBox ? regularBox.querySelector('.price-item--regular') : null;
      const salePrice = saleBox ? saleBox.querySelector('.price-item--sale') : null;
      const comparePriceEl = saleBox ? saleBox.querySelector('.price-item--regular') : null;

      if (comparePrice) {
        priceBox.querySelector('.price')?.classList.add('price--on-sale');
        if (salePrice) salePrice.textContent = price;
        if (comparePriceEl) comparePriceEl.textContent = comparePrice;
      } else {
        priceBox.querySelector('.price')?.classList.remove('price--on-sale');
        if (regularPrice) regularPrice.textContent = price;
      }
    }

    if (mediaItems.length) {
      const targetMediaId = option.dataset.mediaId || '';
      let matched = false;

      mediaItems.forEach((item) => {
        const isTarget = targetMediaId && item.dataset.mediaId === targetMediaId;
        item.style.display = isTarget ? 'block' : 'none';
        if (isTarget) matched = true;
      });

      if (!matched) mediaItems[0].style.display = 'block';
    }
  }

  function initStiffyUpsellCards(root = document) {
    root.querySelectorAll(`${CARD_SELECTOR} ${SELECT_SELECTOR}`).forEach((select) => {
      if (select.dataset.stiffyInitialized === 'true') return;
      select.dataset.stiffyInitialized = 'true';
      select.addEventListener('change', () => updateCard(select));
      updateCard(select);
    });
  }

  function startObserver() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const observer = new MutationObserver(() => {
      initStiffyUpsellCards(drawer);
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initStiffyUpsellCards(document);
      startObserver();
    }, { once: true });
  } else {
    initStiffyUpsellCards(document);
    startObserver();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initStiffyUpsellCards(event.target);
  });
})();
